import React, { useReducer, useContext, createContext } from 'react';
import { store as mainStore } from '../../../../../store';
import moment from 'moment-jalaali';
import axios from '../../../../../api/axios';

export const Store = createContext();

const Provider = ({ children }) => {
  const {
    state: {
      Props: { itemsCountPerPage },
    },
    showMessage,
    showError,
  } = useContext(mainStore);

  const initialState = {
    basePrices: [],
    date: moment(),
    origin: { label: 'گرمسار', value: '5e3dbf566b09850543a67a9a' },
    destination: null,
    fleetOptions: [],
    legalLoad: ['legal'],
    basePrice: null,
    itemsCountPerPage,
    inProgress: false,
    page: 1,
  };

  const reducer = (state, actions) => {
    const { payload, type } = actions;
    switch (type) {
      case 'DATE':
        return { ...state, date: payload };
      case 'CHANGE_ORIGIN':
        return { ...state, origin: payload };
      case 'CHANGE_DESTINATION':
        return { ...state, destination: payload };
      case 'CHANGE_LEGAL_LOAD':
        return { ...state, legalLoad: payload };
      case 'CHANGE_FLEETOPTIONS':
        return { ...state, fleetOptions: payload };
      case 'BASE_PRICE':
        return { ...state, basePrice: payload };
      case 'PROGRESS':
        return { ...state, inProgress: payload };
      case 'PAGE':
        return { ...state, page: payload };
      case 'RESET':
        return { ...initialState };
      case 'SET':
        return { ...state, ...payload };
      case 'BASE_PRICES':
        return { ...state, basePrices: payload };
      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  const {
    date,
    origin,
    destination,
    fleetOptions,
    basePrice,
    itemCountsPerPage,
    legalLoad,
    inProgress,
    page,
  } = state;

  const actions = {
    showMessage,
    showError,
    fetch: async function () {
      try {
        dispatch({ type: 'PROGRESS', payload: true });
        const { data } = await axios.post(`/api/v1/admin/basePrices/fetch`, {
          date,
          origin: origin?.value,
          destination: destination?.value,
          fleetOptions: fleetOptions?.map((fl) => fl._id),
          cargoType: legalLoad,
        });
        // data?.basePrice &&
        //   dispatch({ type: 'BASE_PRICE', payload: data?.basePrice });
      } catch (error) {
        showError(error);
      }
      dispatch({ type: 'PROGRESS', payload: false });
    },
    save: async function () {
      try {
        if (
          origin &&
          destination &&
          fleetOptions?.length &&
          date &&
          legalLoad &&
          basePrice
        ) {
          const { data } = await axios.post(`/api/v1/admin/basePrices/`, {
            origin: origin?.value,
            destination: destination?.value,
            fleetOptions: fleetOptions?.map((fl) => fl._id),
            cargoType: legalLoad,
            date,
            basePrice,
          });
          if (data?.ok) showMessage(data?.messages);
          dispatch({ type: 'RESET' });
        } else showError('کلیه فیلدها الزامی است.');
      } catch (error) {
        showError(error);
      }
    },
    loadList: async function () {
      try {
        dispatch({ type: 'PROGRESS', payload: true });
        const { data } = await axios.post(`/api/v1/admin/basePrices/list`, {
          date,
          origin: origin?.value,
          destination: destination?.value,
          fleetOptions: fleetOptions?.map((fl) => fl._id),
          cargoType: legalLoad,
          page,
          limit: itemCountsPerPage,
        });
        data?.ok &&
          dispatch({ type: 'BASE_PRICES', payload: data?.basePrices });
      } catch (error) {
        showError(error);
      }
      dispatch({ type: 'PROGRESS', payload: false });
    },
    deleteBasePrice: async function (id) {
      try {
        dispatch({ type: 'PROGRESS', payload: true });
        const { data } = await axios.delete(`/api/v1/admin/basePrices/${id}`);
        data?.ok && dispatch({ type: 'RESET' });
      } catch (error) {
        showError(error);
      }
      dispatch({ type: 'PROGRESS', payload: false });
    },
  };

  return (
    <Store.Provider value={{ state, dispatch, actions }}>
      {children}
    </Store.Provider>
  );
};

export default React.memo(Provider);
